export default [
  {
    title: 'Security',
    gjIcon: 'Security',
    children: [
      {
        title: 'SSL Certificate',
        route: 'certificates',
      },
      {
        title: 'API Keys',
        route: 'api-keys',
      },
    ],
  },
]
